import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    standalone: false
})
export class UnauthorizedComponent implements OnInit, OnDestroy {
  adminRoot = environment.adminRoot;

  constructor() { }

  ngOnInit(): void {
    document.body.classList.add('background');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('background');
  }

}
